import { useEffect, useState } from 'react';
import { TrialDetailsService } from '../../core/services/trial-details.service';
import useAnalyticsTracker from '../../analytics/hooks/useAnalyticsTracker';
import useService from '../../injector/hooks/useService';
import useUserService from '../../auth/hooks/useUserService';

export function useScheduleCall() {
  const [ visible, setVisible ] = useState(false);
  const { eventTrack } = useAnalyticsTracker();
  const trialDetailsService = useService(TrialDetailsService);
  const { user } = useUserService();

  const openScheduleCallLink = (url: string, action: string, section: string) => {
    const scheduleCallUrl = new URL(url, window.location.origin);

    if (user?.email) {
      scheduleCallUrl.searchParams.set('email', user.email);
    }

    window.open(scheduleCallUrl.toString(), '_blank');

    eventTrack({
      action: action,
      properties: {
        section: section
      }
    });
  };

  useEffect(() => {
    const sub = trialDetailsService.trialDetails$.subscribe(details => {
      setVisible(details.isInTrial());
    });

    return () => {
      sub.unsubscribe();
    };
  }, []);

  return {
    openScheduleCallLink,
    scheduleCallVisible: visible
  };
}
